<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-3">
        <button
          type="button"
          class="btn btn-success btn-block"
          @click="getReport"
        >
          <i class="fas fa-redo"></i> ประมวลผล
        </button>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/pdf/report_sale_summary.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-primary btn-block"
          >
            <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
          </button>
        </form>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/excel/report_sale_summary.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-info btn-block"
          >
            <i class="far fa-file-excel"></i> บันทึกเป็น Excel
          </button>
        </form>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div class="table-responsive-sm mt-3">
      <table class="table">
        <thead>
          <tr class="text-left">
            <td colspan="6">จุดขาย: {{ host.host_name }}</td>
          </tr>
        </thead>
        <tbody>
          <tr class="thead-dark">
            <th>วันที่</th>
            <th width="20%">จำนวนใบเสร็จ</th>
            <th width="20%">จำนวนสินค้า</th>
            <th width="20%">ราคารวม</th>
            <th width="10%">ส่วนลด</th>
            <th width="20%">ราคาสุทธิ</th>
          </tr>
          <tr
            v-for="(r, i) in report_data"
            :key="'datar' + i"
          >
            <td class="text-center">{{ dateFormatDMY(r.doc_date) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.bill_count) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.count_item) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.item_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.discount_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.total_amount) }}</td>
          </tr>
          <tr v-if="report_data.length !== 0">
            <th
              colspan="8"
              class="text-right"
            >### รวมรายการสินค้าจำนวน: {{ report_data.length }} ###</th>
          </tr>
          <tr v-if="report_data.length !== 0">
            <th class="text-center">รวมรายการจุดขาย : {{ host.host_name }}</th>
            <th class="text-right">{{ numberFormatDecimal(bill_count(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(count_item(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(item_amount(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(discount_amount(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(total_amount(report_data)) }}</th>
          </tr>
          <tr class="thead-dark" v-if="report_data.length !== 0">
            <th class="text-center">รวมทั้งสิ้น</th>
            <th class="text-right">{{ numberFormatDecimal(bill_count(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(count_item(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(item_amount(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(discount_amount(report_data)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(total_amount(report_data)) }}</th>
          </tr>
        </tbody>
        <tbody v-if="report_data.length === 0">
          <tr>
            <th
              scope="row"
              colspan="8"
            >ไม่มีข้อมูล</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../services/service_report'

export default {
  props: ['host', 'startDate', 'endDate'],
  data () {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: JSON.stringify(this.host)
    }
  },
  methods: {
    getReport () {
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: this.$store.state.user.branch_id,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate)
      }
      this.$store.commit('Loading')
      api.saleSummary(
        this.REST_URL,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    bill_count (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['bill_count']
      })
      return sum
    },
    item_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['item_amount']
      })
      return sum
    },
    discount_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['discount_amount']
      })
      return sum
    },
    before_tax_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['before_tax_amount']
      })
      return sum
    },
    tax_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['tax_amount']
      })
      return sum
    },
    total_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['total_amount']
      })
      return sum
    },
    count_item (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['count_item']
      })
      return sum
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/report/report_sale_summary.vue